import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@citydeals/env';
import { GiftWrapperModel, ShippingModel } from './state/model/basket-overview-gift-form.model';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService {
  constructor(
    private httpClient: HttpClient,
  ) {}

  getWrappings(): Observable<GiftWrapperModel[]> {
    return this.httpClient.get<GiftWrapperModel[]>(
      `${environment.backendUrl}/client/purchase/wrapping`
    );
  }

  getShippingModes(): Observable<ShippingModel[]> {
    return this.httpClient.get<ShippingModel[]>(
      `${environment.backendUrl}/client/purchase/shipping`
    );
  }
}
